import DashboardLanding from './DashboardLanding'

export default DashboardLanding
